module.exports = __webpack_public_path__ + "img/blue_121.0ebd23a1.png";